import { EventSeriesOrderData } from '@beat-venues/common-types';
import {
    ButtonOrLink,
    EventDetailWrapper,
    Heading,
    Logo,
    Text,
} from '@beat-venues/ui/react';
import { useTranslation } from 'react-i18next';

interface VipTilesProps {
    event: EventSeriesOrderData;
}

export const VipTile = ({ event }: VipTilesProps) => {
    const { t, i18n } = useTranslation();
    return (
        <EventDetailWrapper
            className="vip-tile order-6 w-full overflow-visible md:order-4 md:w-auto"
            type="content"
        >
            {event.vipUpgrade ? (
                <ButtonOrLink
                    className="flex h-full flex-col items-center justify-between"
                    href={
                        event.vipUpgrade?.[
                            i18n.language as keyof typeof event.vipUpgrade
                        ] ?? '#'
                    }
                >
                    <Heading as="h5" className="font-normal">
                        {t('events.vipTickets.vipUpgradeTitle')}
                    </Heading>
                    <Logo className="h-20" venueId="vip" />
                    <Text>{t('events.vipTickets.vipUpgradeSubtitle')}</Text>
                </ButtonOrLink>
            ) : event.isVip ? (
                <ButtonOrLink
                    className="flex h-full flex-col items-center justify-between"
                    href={
                        process.env[
                            `VITE_IXPOLE_PACKAGES_URI_${i18n.language.toUpperCase()}`
                        ]
                    }
                >
                    <Heading as="h5" className="font-normal">
                        {t('events.vipTickets.vipTitle')}
                    </Heading>
                    <Logo className="h-20" venueId="vip" />
                    <Text>{t('events.vipTickets.vipSubtitle')}</Text>
                </ButtonOrLink>
            ) : (
                <ButtonOrLink
                    className="flex flex-col items-center gap-1"
                    href={`https://cashless.beatvenues.be/${i18n.language}/home`}
                >
                    <Heading as="h5" className="font-normal">
                        {t('events.cashLessTitle')}
                    </Heading>
                    <Logo className="h-18" venueId="beat" />
                    <Text className="mt-3">{t('events.cashLessSubTitle')}</Text>
                </ButtonOrLink>
            )}
        </EventDetailWrapper>
    );
};
